<ion-app>
  @if (isUpdateRequired() === undefined) {
    <p class="ion-text-center">{{ 'general.check_version' | translate }}</p>
  } @else {
    <ion-split-pane
      when="md"
      contentId="main"
    >
      @if (isAuthenticateUser() && !isUpdateRequired()) {
        @if (!(userCapabilities$ | async)?.includes(ECapabilities.UPLOAD_FREIGHTS)) {
          Hola, Antonio. Estás intentando entrar en la aplicación de cargadores, pero tienes permisos en la plataforma
          como transportista. Aquí tienes el enlace a la
          <a href="https://carriers.okcargo.io">aplicación de transportistas</a>
          .
        } @else {
          <ion-menu
            contentId="main"
            [side]="menuPosition()"
          >
            <app-menu-header></app-menu-header>

            <ion-content>
              <app-menu-main></app-menu-main>
            </ion-content>

            <ion-footer>
              <app-menu-footer></app-menu-footer>
            </ion-footer>
          </ion-menu>
        }
      }

      <ion-router-outlet id="main"></ion-router-outlet>
    </ion-split-pane>
  }
</ion-app>
